export default __webpack_public_path__ + "static/media/haeuser_intro_web-sm@1x.04106690.jpg";